import React, { useCallback, useEffect, useRef } from "react"
import { useState } from "react"
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import EncounterMenuSearch from "./EncounterMenuSearch"
import { connect, useSelector } from "react-redux";
import { TabActionEncounterMenu } from "../../actions/EncounterMenuActions";
import EncounterMenuTab from './EncounterMenuTab'
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import ModalHeader from "../Setup/Shared/ModalHeader";
import TextEditor from "../../shared-components/TextEditor";
import DatePicker from "../General/DatePicker";
import handleCopyText from "../shared/CopyData";
import { isChildWindow } from "../../utils/Constants";
// import EncounterMenuAttendance from "./EncounterMenuAttendance";
// import { GeneralDropDowns } from "../../actions/GeneralEncounterMenuActions";
import DiscardChangesPopup from "../shared/DiscardChanges/DiscardChangesPopup";
import { debounce } from "lodash";
import EncounterWrapper from "./EncounterMenuDetails/EncounterWrapper/EncounterWrapper";

const EncounterMenu = (props) => {
    let EncounterMenuData = useSelector(state => state.Open_EncounterMenu_Tab);
    const [recordsNum, setRecordsNum] = useState(false);
    const aiSession = useSelector(state => state.ResumeAISessionReducer);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const IsAdultDayCare = DropDowns.IsAdultDayCare;

    let dispatch = useDispatch();
    const [tabList, setTabsList] = useState(
        isChildWindow ? [] : [{
            active: true,
            key: 2,
            name: "EncounterMenu",
            data: {
                name: "All Encounters",
                id: 0,
                component: <EncounterMenuSearch setRecordsNum={setRecordsNum} />,
            },
        },
            // ...(IsAdultDayCare === 'true' ? [{
            //     active: true,
            //     key: 2,
            //     name: "EncounterMenu",
            //     data: {
            //         name: "EncounterMenu Attendance",
            //         id: 1,
            //         component: <EncounterMenuAttendance setRecordsNum={setRecordsNum} />,
            //     },
            // }] : []),
        ])

    const [activeTab, setActiveTab] = useState(0)


    useEffect(() => {
        if (props.OpenDynamicTab && props.OpenDynamicTab.length > 0) {
            AddDynamicTabData(props)
        }
        else {

            let obj = {
                active: true,
                key: 2,
                name: "EncounterMenu",
                data: {
                    name: "All Encounters",
                    id: 0,
                    component: <EncounterMenuSearch setRecordsNum={setRecordsNum} />,
                },
            }
            // setTabsList(obj)
            props.TabActionEncounterMenu(obj);
            setActiveTab(0)
        }

    }, [props.OpenDynamicTab])

    const AddDynamicTabData = (data) => {

        let tabDataFromRedux = data.OpenDynamicTab.length > 0 ? data.OpenDynamicTab : [];
        const DataFromRedux = tabDataFromRedux.filter((ele) => { return ele.key === 2; });   // fetch only whose id is 2
        const activeElements = DataFromRedux.filter((row) => row.active === true); // get active 
        let LengthCheck = IsAdultDayCare === "true" ? tabList.length === 2 : tabList.length === 1;
        if (activeElements.length > 0 && LengthCheck) {
            ///////////////////////////
            // let tabsData = [...tabList]
            // tabsData = tabsData.concat(...DataFromRedux)
            //////////////////////////
            const mapKey = (tab) => `${tab.key}_${tab.data.id}`;
            const tabsMap = new Map(tabList.map(tab => [mapKey(tab), tab]));
            for (const newTab of DataFromRedux) {
                tabsMap.set(mapKey(newTab), newTab); // Replaces if exists, adds if not
            }
            const tabsData = Array.from(tabsMap.values());
            /////////////////////////////
            setTabsList(tabsData)

            setActiveTab(activeElements[0].data.id)
        } else {
            let firstEncounterMenuTab = tabList.filter((el) => el?.data?.id === 0 || el?.data?.id === 1);

            let tabs = [...firstEncounterMenuTab]
            // check if all pat exist in redux 

            const isExist = tabDataFromRedux.some((ele) => { return ele.key === 2 && (ele?.data?.id === 0 || ele?.data?.id === 1); });
            if (isExist) {
                setTabsList(DataFromRedux)
            } else {
                tabs = tabs.concat(...DataFromRedux)
                setTabsList(tabs)
            }
            console.log("activeElements[0].data.id", activeElements)
            setActiveTab(activeElements[0].data.id)
            // setActiveTab(0)
        }
    }
    // active tab 
    const handleActiveTab = (item) => {
        if (isChildWindow) return;

        const { data } = { ...item }
        if (activeTab !== data?.id) {
            setActiveTab(data?.id)
        }

        // if (item?.data?.id !== 0 && item?.data?.id !== 1) {
        let obj = {
            key: 2,
            name: "EncounterMenu",
            active: true,
            data: {
                id: data?.id,
                name: data?.name,
                time: new Date(),
                ...((data?.name === "All Encounters" && data?.id === 0) ? {} : {
                    patid: data?.patid,
                    type: data?.type,
                }),
                component: data?.component,
                groupEncounter: item.data.groupEncounter
            },
        };
        props.TabActionEncounterMenu(obj);
        // }

    }

    let DiscardIndicator = useSelector(state => state.GeneralDropDownsReducer.DiscardIndicator)
    let GenDD = useSelector(state => state.GeneralDropDownsReducer)
    // handle to close tab
    const [pendingTabClose, setPendingTabClose] = useState(null);

    // console.log(GenDD?.DisCardActiveIds.EncounterMenu);

    const handleCloseTab = async (id) => {
        // let DD = GenDD
        // DD?.DisCardActiveIds.EncounterMenu.map((item) => {
        //     if (item.EncounterMenuID + "" === id + "") {
        //         if (item.isDemographicsOpened || item.isInsuranceOpened) {
        //             // dispatch(GeneralDropDowns({
        //             //     ...GenDD, DiscardIndicator: true,
        //             // }))

        //             // dispatch(GeneralDropDowns({
        //             //     ...GenDD, DiscardIndicator: true, DisCardActiveIds: {
        //             //         ...GenDD?.DisCardActiveIds,
        //             //         EncounterMenu: {
        //             //             ...GenDD?.DisCardActiveIds.EncounterMenu,
        //             //             EncounterMenuID: id,
        //             //         }
        //             //     }
        //             // }))
        //             setPendingTabClose(id); // Store pending tab close ID
        //         } else {

        if (aiSession?.activeRecordingEncounterId === id) return;

        let index = tabList.findIndex((el) => el?.data?.id === id);
        tabList.splice(index, 1);
        let activTab =
            tabList.length > 0
                ? tabList[tabList.length - 1]?.data?.id
                : 0;
        setTabsList(tabList)

        activeTab === id && setActiveTab(activTab)

        props.TabActionEncounterMenu({}, id);
        dispatch({ type: "RECORDING_STOPPED", payload: { encounterId: id } });
    };
    useEffect(() => {
        if (DiscardIndicator === false && pendingTabClose !== null) {
            let DD = GenDD
            DD?.DisCardActiveIds.EncounterMenu.map((item) => {
                if (item.EncounterMenuID + "" === pendingTabClose + "") {
                    if (item.isDemographicsUpdated || item.isInsuranceUpdated) {
                        // dispatch(GeneralDropDowns({
                        //     ...GenDD, DiscardIndicator: true,
                        // }))
                        setIsDiscardChanges(true)
                    } else {
                        handleCloseEncounterMenu()
                    }
                }
            })
        }
    }, [DiscardIndicator, pendingTabClose]);


    const [isDiscardChanges, setIsDiscardChanges] = useState(false)

    const onProceedWithDiscardChanges = () => {
        handleCloseEncounterMenu()
        // dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: false }))
        setIsDiscardChanges(false)
    }

    const handleCloseEncounterMenu = () => {
        let index = tabList.findIndex((el) => el.data.id === pendingTabClose);
        tabList.splice(index, 1);
        let activTab =
            tabList.length > 0
                ? tabList[tabList.length - 1].data.id
                : 0;

        setTabsList(tabList)

        setActiveTab(activTab)
        props.TabActionEncounterMenu({}, pendingTabClose);

        // will be remove from the list => first find id of the patient from list  DisCardActiveIds.patient then remove the pateint 
        const updatedEncounterMenus = GenDD?.DisCardActiveIds.EncounterMenu.filter(
            item => item.EncounterMenuID + "" !== pendingTabClose + ""
        );
        // dispatch(GeneralDropDowns({
        //     ...GenDD,
        //     DiscardIndicator: false,
        //     DisCardActiveIds: {
        //         ...GenDD?.DisCardActiveIds,
        //         EncounterMenu: updatedEncounterMenus,
        //     }
        // }));
        setPendingTabClose(null); // Reset pending tab
    }
    const handleCancelDiscard = () => {
        setIsDiscardChanges(false)
        // dispatch(GeneralDropDowns({ ...GenDD, DiscardIndicator: null }))
    }

    let DiscardPopup
    if (isDiscardChanges) {
        DiscardPopup = <DiscardChangesPopup isDiscardChanges={isDiscardChanges} handleCancelDiscard={handleCancelDiscard} onProceedWithDiscardChanges={onProceedWithDiscardChanges} />
    }


    let SideBarActiveKey = useSelector(state => state.SidebarActiveTab);

    const comboKeys = useRef([]); // ✅ Holds current key sequence
    const isInputFocused = () => {
        const activeElement = document.activeElement;
        return (
            activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.tagName === 'SELECT' ||
            activeElement.isContentEditable
        );
    };
    const executeCombo = useCallback(
        debounce(() => {
            if (isInputFocused()) {
                comboKeys.current = []; // Clear combo if input is focused
                return;
            }
            const sequence = comboKeys.current.join('+');
            if (SideBarActiveKey === 2) {
                if (sequence === 'escape') {
                    let activePatinet = EncounterMenuData.filter((el) => el.active === true)[0]
                    handleCloseTab(activePatinet?.data?.id)
                }
            } else {
            }
            comboKeys.current = []; // ✅ Clear combo after handling
        }, 500), [SideBarActiveKey, activeTab])

    useEffect(() => {
        const handleKeyDown = (event) => {
            // if (!event.altKey) return;
            if (isInputFocused()) {
                return;
            }
            const key = event.key.toLowerCase();

            // if (['n', 'r', 'p', 'escape'].includes(key)) {
            //     event.preventDefault();
            //     event.stopPropagation();
            // }
            comboKeys.current.push(key);
            executeCombo(); // Debounced logic
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            executeCombo.cancel(); // ✅ Clean up debounce
        };
    }, [executeCombo]);


    const disableDiv = <div className="app_tooltip right">
        <span class="icon-cross-cricle fs-15 ar-disabled">
            <span class="path1"></span><span class="path2"></span>
        </span>
        <p class="tool_tip xsm_text text-light">You can’t close this encounter while AI recording is active.</p>
    </div>
    return (
        <>
            {DiscardPopup}
            <div className='app-tabs fix-tabs'>
                <Nav className="rb-tabs bg-light-blue nav-tabs pt-1 hk-cross-tabs ar_tabs-changes">
                    {tabList && tabList.map((item) => {
                        return (
                            <React.Fragment key={item?.data?.id}>
                                <NavItem >
                                    <NavLink
                                        href="#"
                                        className={activeTab === item?.data?.id ? "active" : ""}
                                        onClick={() => {
                                            handleActiveTab(item);
                                        }}
                                    >
                                        {item?.data?.name}

                                    </NavLink>
                                    {(item.data?.id === 0 || item.data?.id === 1) ? null :
                                        aiSession?.activeRecordingEncounterId === item?.data?.id ?
                                            !isChildWindow &&
                                               disableDiv
                                            :
                                            !isChildWindow && <span onClick={() => handleCloseTab(item?.data?.id)} class="icon-cross-cricle fs-15"><span class="path1"></span><span class="path2"></span></span>
                                    }
                                    {item?.data?.id === 0 && recordsNum !== 0 ? <div className="counter heading">{recordsNum}</div> : null}
                                </NavItem>
                            </React.Fragment>
                        )
                    })}
                </Nav>
                <TabContent activeTab={activeTab}>
                    {tabList &&
                        tabList.filter((el) => (el?.data?.id === 0 || el?.data?.id === 1)).map((item) => {
                            return (
                                <React.Fragment key={item?.data?.id}>
                                    <TabPane tabId={item?.data?.id}>
                                        {item?.data?.component}
                                    </TabPane>
                                </React.Fragment>
                            )
                        })}
                    {tabList &&
                        tabList.filter((el) => (el?.data?.id !== 0 && el?.data?.id !== 1)).map((item) => {
                            return (
                                <React.Fragment key={item?.data?.id}>
                                    <TabPane tabId={item?.data?.id} className={'encounter-menu-active-tab'}>
                                        {/* <EncounterMenuTab Active={activeTab} /> */}
                                        <EncounterWrapper Reload={false} id={[{ key: 218, name: 'Target Record' }]} />
                                    </TabPane>
                                </React.Fragment>
                            )
                        })}

                </TabContent>
            </div>

            {/* Alert Message Modal */}
            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal ar_palceholder">
                <Modal.Body>
                    <ModalHeader HeaderName={() => { }} DeletePopup={""} isClosed={() => { }} key={631} Name={'SwitchPractice'} />
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">Alert Message</p>

                                    <div className="opened-block__lite">
                                        <TextEditor value={"Hi John.............."} />

                                        <div className="row opened-block__lite__form">
                                            <div className="col-5 mt-2">
                                                <DatePicker
                                                    label='Start Date'
                                                    value={""}
                                                    handleCalendarChangefunc={() => { }}
                                                />
                                            </div>
                                            <div className="col-5 mt-2">
                                                <DatePicker
                                                    label='End Date'
                                                    value={""}
                                                    handleCalendarChangefunc={() => { }}
                                                />
                                            </div>
                                            <div className="col-6 mt-2">
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="global" />
                                                    <label className="form-check-label" for="global">Global</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="appointement" />
                                                    <label className="form-check-label" for="appointement">Show Alert in Appointment Section</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="patient" />
                                                    <label className="form-check-label" for="patient">Show Alert in EncounterMenu Section</label>
                                                </div>
                                            </div>
                                            <div className="col-6 mt-2">
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="appointement" />
                                                    <label className="form-check-label" for="appointement">Show Alert in Claim Section</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="patient" />
                                                    <label className="form-check-label" for="patient">Show Alert in Payment Section</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                    <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">Save</button>
                                    <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_close">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Alerts Small Modal */}
            {/* <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal hk-alerts_box hk-alerts_leftBox ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Patient ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}

            {/* <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal hk-alerts_box ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Patient ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}

            {/* <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg master_list_modal hk-alert__modal hk-alerts_box hk-modal-v1 hk-alerts_rightBox ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Patient ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
        </>
    )
}

function mapStateToProps(state) {
    return {
        OpenDynamicTab: state.Open_EncounterMenu_Tab ? state.Open_EncounterMenu_Tab : [],
    };
}

const action = {
    TabActionEncounterMenu,
};


export default connect(mapStateToProps, action)(EncounterMenu)

